// extracted by mini-css-extract-plugin
export default {"default-metadata-container":"default-metadata-container-8b3e","row":"row-10b7","value":"value-557a"};